function gmaps_relay() {
    const myStyles = [
        {
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f5f5f5"
                }
            ]
        },
        {
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#616161"
                }
            ]
        },
        {
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "color": "#f5f5f5"
                }
            ]
        },
        {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#bdbdbd"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#eeeeee"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#757575"
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#e5e5e5"
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#9e9e9e"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#ffffff"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#757575"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#dadada"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#616161"
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#9e9e9e"
                }
            ]
        },
        {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#e5e5e5"
                }
            ]
        },
        {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#eeeeee"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#c9c9c9"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#9e9e9e"
                }
            ]
        }
    ];

    // Map default options.
    const defaultOptions = {
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        styles: myStyles,
        restriction: {
            latLngBounds: {
                east: 179.999,
                north: 89.999,
                south: -89.999,
                west: -179.999
            },
            strictBounds: true
        },
        minZoom: 2,
        maxZoom: 18,
    };

    // Input search address
    let input_map_address = document.getElementById('input_map_address');

    // Map object.
    var map;

    // Map markers array.
    let markers = [];

    // Map popin selected reseller
    var map_selected;

    // Map markers array of selected reseller.
    let marker_selected;

    var geocoder;


    /**
     * Init reseller map for Mantion relay shipping mode.
     */
    function initMap() {
        // Create map.
        map = new google.maps.Map(document.getElementById('map_relay'), {
            ...defaultOptions,
            ...{
                center: new google.maps.LatLng(48.870780 , 2.354840),
                zoom: 10,
            }
        });

        geocoder = new google.maps.Geocoder();

        // Autocomplete
        var autocomplete = new google.maps.places.Autocomplete(input_map_address, {
            fields: ['formatted_address', 'geometry', 'name'],
            componentRestrictions: {country: ['fr']}
        });
        autocomplete.bindTo('bounds', map);
        autocomplete.addListener('place_changed', function() {
            var place = autocomplete.getPlace();

            console.log(place);

            if (!place.geometry || !place.geometry.location) {
                alert('Aucun détail disponible pour la recherche : ' + place.name);
                return;
            }

            if (place.geometry.viewport) {
                map.fitBounds(place.geometry.viewport);
            }
            else {
                map.setCenter(place.geometry.location);
            }

            map.setZoom(7);

            var latitude = place.geometry.location.lat();
            var longitude = place.geometry.location.lng();

            searchAndDisplayResellersForRelay({'latitude': latitude, 'longitude': longitude});
        });

        var $coordinates = $('#customer_billing_address_coordinates');
        if ($coordinates.length > 0) {
            searchAndDisplayResellersForRelay({'latitude': $coordinates.attr('data-latitude'), 'longitude': $coordinates.attr('data-longitude')});
        }
    }

    function initMapSelected(reseller) {
        // Create map.
        if (!map_selected) {
            map_selected = new google.maps.Map(document.getElementById('map_relay_selected'), {
                ...defaultOptions,
                ...{
                    center: new google.maps.LatLng(reseller.latitude, reseller.longitude),
                    zoom: 14,
                }
            });
        }

        map_selected.setCenter(new google.maps.LatLng(reseller.latitude, reseller.longitude));
        map_selected.setZoom(14);

        if (marker_selected) {
            marker_selected.setMap(null);
        }

        // Create map marker.
        marker_selected = new google.maps.Marker({
            position: new google.maps.LatLng(reseller.latitude, reseller.longitude),
            title: reseller.title,
            map: map_selected,
            icon: {
                url: directory_uri.stylesheet_directory_uri + '/assets/img/CURSEUR_REVENDEUR.png',
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(0, 50)
            },
            reseller_id: reseller.post_id,
        });

        let html = '';

        // Handle click on map marker.
        google.maps.event.addListener(marker_selected, 'click', (function(marker_selected) {
            return function() {
                infoWindow.setContent('<div class="reseller-ct info-window">'+html+'</div>');
                infoWindow.open(map_selected, marker_selected);
            }
        })(marker_selected));
    }

    function cleanMarkers() {
        for (var i in markers) {
            markers[i].setMap(null);
        }

        markers = [];
    }

    function searchAndDisplayResellersForRelay(params, userPosition = null, cb = null) {
        $.ajax({
            method: 'POST',
            url: mantion.ajaxurl,
            data: {
                'action': 'search_resellers_relay',
                'params': params
            },
            beforeSend: function(xhr) {
                //xhr.setRequestHeader("X-WP-Nonce", window.mtn.api.nonce);
            },
            success: function(response) {
                console.log(response);

                cleanMarkers();

                // Reset resellers list.
                $('#results_relay ul').html('');

                // If resellers, fill the map.
                if (response.success && response.data.length > 0) {
                    $('.message').hide();
                    $('.count-results-relay').show();

                    const infoWindow = new google.maps.InfoWindow({
                        content: '',
                    });

                    var reseller;

                    for (var i in response.data) {
                        reseller = response.data[i];

                        let html = '<div class="reseller-info">';

                        if (reseller.logo) {
                            html += '<div class="logo"><img src="' + reseller.logo + '"></div>';
                        }
                        else {
                            html += '<div class="logo"><img src="/wp-content/themes/mantion/assets/img/reseller-placeholder.svg"></div>';
                        }

                        html += '<h3 data-latitude="'+reseller.latitude+'" data-longitude="'+reseller.longitude+'">' + reseller.title  + '</h3>'+
                            '<p>' + reseller.street + '</p><p>' + (reseller.loc ? reseller.loc + '</p></p>' : '') + reseller.zip_code + ' '+ reseller.city +'</p>';

                        if (reseller.phone) {
                            html += '<p>Tel : ' + reseller.phone + '</p>';
                        }

                        if (reseller.fax) {
                            html += '<p>Fax : ' + reseller.fax + '</p>';
                        }

                        if (reseller.website && reseller.website !== '.') {
                            let vendorUrl;

                            if (reseller.website.indexOf("http") < 0) {
                                vendorUrl = "http://" + reseller.website;
                            }
                            else {
                                vendorUrl = reseller.website
                            }
                            if (vendorUrl) {
                                html += '<p>Site : ' + '<a target="_blank" href="' + vendorUrl + '">' + reseller.website + '</a></p>';
                            }
                        }

                        if (reseller.email && reseller.email !== '.') {
                            html += '<a class="mail-link" href="mailto:'+ reseller.email + '">' + mantion.resellers.send_an_email + '</a>';
                        }

                        if (reseller.is_mantion_relay == 1) {
                            html += '<div class="mantion-relay-top"><img title="' + mantion.resellers.mantion_relay + '" src="/wp-content/themes/mantion/assets/img/RETRAIT-MANTION.svg"></div>'
                            html += '<div class="mantion-relay-bottom"><img title="' + mantion.resellers.mantion_relay + '" src="/wp-content/themes/mantion/assets/img/RETRAIT-MANTION.svg">' + mantion.resellers.mantion_relay + '</div>'
                        }

                        html += '</div>';

                        // If a position is given, add a distance text below the reseller infos.
                        if (userPosition) {
                            html += '<p class="distance"><img src="' + directory_uri.stylesheet_directory_uri + '/assets/img/BOUSSOLE_KM.svg' + '" alt=""/>' + Math.round(reseller.distance*100)/100 + ' km</p>';
                        }

                        html += '<div class="relay-bottom">';

                        html += '<div class="relay-hours">';
                        html += '  <span class="toggle-hours">' + mantion.resellers.hours + ' <i class="fa fa-angle-down"></i></span>';
                        html += '  <ul class="relay-hours__detail">';
                        for (let _day in reseller.hours) {
                            var day = reseller.hours[_day];
                            html += '<li>';
                            html += '  <span class="hours-day">' + mantion.days[_day] + '</span>';
                            if (day.open === '1') {
                                html += '<span class="hours-hours">' + day.hours + '</span>';
                            }
                            else {
                                html += '<span class="hours-hours">' + mantion.closed + '</span>';
                            }
                            html += '</li>';
                        }
                        html += '  </ul>';
                        html += '</div>';

                        var selected = $('#mtn-relay-mantion-id').val() == reseller.post_id ? 'selected' : '';
                        html += "<button data-id=" + reseller.post_id + " class='select-relay button " + selected + "'>" + mantion.resellers.choose_this_reseller + "</button>";

                        html += '</div>'; // End .relay-bottom

                        // Append to results node.
                        var $li = $('<li class="reseller-ct" id="reseller-relay-' + reseller.post_id + '">' + html + '</li>');
                        $li.data('reseller', reseller);
                        $('#results_relay > ul').append($li);

                        // Create map marker.
                        const marker = new google.maps.Marker({
                            position: new google.maps.LatLng(reseller.latitude, reseller.longitude),
                            title: reseller.title,
                            map: map,
                            icon: {
                                url: directory_uri.stylesheet_directory_uri + '/assets/img/CURSEUR_REVENDEUR.png',
                                origin: new google.maps.Point(0, 0),
                                anchor: new google.maps.Point(0, 50)
                            },
                            reseller_id: reseller.post_id,
                        });

                        // Handle click on map marker.
                        google.maps.event.addListener(marker, 'click', (function(marker, i) {
                            return function() {
                                infoWindow.setContent('<div class="reseller-ct info-window">'+html+'</div>');
                                infoWindow.open(map, marker);
                            }
                        })(marker, i));

                        // Add marker to markers list.
                        markers.push(marker);
                    }

                    // Move map to given position or first reseller's position.
                    if (userPosition) {
                        map.panTo(new google.maps.LatLng(userPosition.coords.latitude, userPosition.coords.longitude));
                    }

                    // Set map zoom to fit all markers in map
                    if (markers) {
                        var bounds = new google.maps.LatLngBounds();
                        for (var idx = 0; idx < markers.length; idx++) {
                            bounds.extend(markers[idx].getPosition());
                        }
                        map.fitBounds(bounds);
                    }

                    // Set map zoom level depending on wether we are focusing on a single country or not.
                    map.setZoom(7);
                }

                $('#total_relay').text(response.data.length);

                // Stop loading animation.
                $('.infinite-loader').removeClass('active');

                // Call callback.
                if (cb) {
                    cb(response);
                }
            },
            error: function(xhr,error) {
                $('.infinite-loader').removeClass('active');
                $('.message').show();
            },
        });
    }

    $('body').on('click', '.select-relay', function(e) {
        e.preventDefault();

        var $that = $(this);
        var data = $that.closest('li.reseller-ct').data('reseller');

        console.log(data);

        if (!$that.hasClass('selected')) {
            $('#results_relay .select-relay.selected').removeClass('selected');
            $that.addClass('selected');

            $('.selected-relay-mantion').show();

            $('#mtn-relay-mantion-id').val(data.post_id);

            $('.selected-relay-mantion__infos__title').text(data.title);
            if (data.loc) {
                $('.selected-relay-mantion__infos__address').html(data.street + '<br>' + data.loc);
            }
            else {
                $('.selected-relay-mantion__infos__address').text(data.street);
            }
            $('.selected-relay-mantion__infos__address_2').text(data.zip_code + ' ' + data.city);
            $('.selected-relay-mantion__infos__country').text(data.country);

            for (let _day in data.hours) {
                var day = data.hours[_day];

                if (day.open === '1') {
                    $('.selected-relay-mantion-popup-hours__hours__' + _day + ' .hours').text(day.hours);
                }
                else {
                    $('.selected-relay-mantion-popup-hours__hours__' + _day + ' .hours').text(mantion.closed);
                }
            }

            initMapSelected(data);
        }
        else {
            $that.removeClass('selected');

            $('.selected-relay-mantion').hide();

            $('#mtn-relay-mantion-id').val('');
        }
    });

    /**
     * Handle user's click on the "Locate me" button.
     */
    $('#locateMe_relay').click(function(e) {
        e.preventDefault();

        if (!navigator.geolocation) {
            alert("Sorry, your browser does not support HTML5 geolocation.");
            return;
        }

        // Find user location.
        navigator.geolocation.getCurrentPosition(
            function(position) {
                // Get address from latitude and longitude
                const latlng = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
                geocoder.geocode({ location: latlng }, (results, status) => {
                    if (status === "OK") {
                        if (results[0]) {
                            map.setCenter(new google.maps.LatLng(position.coords.latitude, position.coords.longitude));
                            map.setZoom(7);

                            $('#input_map_address').val(results[0].formatted_address);
                        } else {
                            console.log('no address found');
                        }
                    } else {
                        console.log("Geocoder failed due to: " + status);
                    }
                });

                // Fetch resellers based on user's position + center map on user's position.
                searchAndDisplayResellersForRelay({'latitude': position.coords.latitude, 'longitude': position.coords.longitude});
            },
            function (error) {
                if (mantion.geolocalisation.errors[`code_${error.code}`]) {
                    alert(mantion.geolocalisation.errors[`code_${error.code}`]);
                }
                else {
                    alert(error.message);
                }

                console.warn(`ERROR ${error.code}: ${error.message}`);
            });
    });

    /**
     * Recenter map when user clicks on a reseller in the resellers list.
     */
    $('body').on('click', '#results_relay.map--results h3', function() {
        let latitude = parseFloat($(this).attr('data-latitude'));
        let longitude = parseFloat($(this).attr('data-longitude'));

        map.panTo(new google.maps.LatLng(latitude, longitude));
        map.setZoom(13);

        $('html, body').animate({
            scrollTop: $('#map_relay').offset().top - 190
        }, 1000);
    });

    $('body').on('click', '.relay-hours .toggle-hours', function(e) {
        if ($(this).parent().hasClass('active')) {
            $(this).find('i').removeClass('fa-angle-up').addClass('fa-angle-down');
            $(this).parent().removeClass('active');
        }
        else {
            $(this).find('i').removeClass('fa-angle-down').addClass('fa-angle-up');
            $(this).parent().addClass('active');
        }
    });

    initMap();
}

export { gmaps_relay };
